import StoredLayout from '../../layouts/StoredLayout'
import Geographic from './Geographic'
export default StoredLayout(Geographic)



// WEBPACK FOOTER //
// ./src/dashboards/geographic/index.js